import './JiraStatusMapping.scss';

import { ArrowRightOutlined } from '@ant-design/icons';
import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { InitiativeStatusSelector } from '../../initiatives/StatusSelector';
import { SonarText } from '@ui/text';

import { Col, Row } from 'antd';
import { integrationsActions, JiraStatus } from '@sonar-software/sonar-integrations';
import { jiraStatusSelectors, jiraSummarySelectors } from './@arch/selectors';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';

export interface JiraStatusMappingProps {
	status: JiraStatus;
}

export const JiraStatusMapping: React.FC<JiraStatusMappingProps> = ({ status }) => {
	const { customerId } = useCurrentUser();

	const postJiraStatus = useAction(integrationsActions.requestPostJiraStatuses);
	const isReceived = useSonarSelector(jiraSummarySelectors.isReceived);

	const handleStatusChange = useCallback(
		(jiraStatusId: string) => (initiativeStatusId: number) => {
			postJiraStatus({
				customerId,
				initiativeStatusId,
				jiraStatusId
			});
		},
		[ customerId, postJiraStatus ]
	);

	const defaultValue = status.initiativeStatusId ? String(status.initiativeStatusId) : 'Select Arovy Status';

	return (
		<div className='jira-status-mapping'>
			<Row key={ status.jiraStatusId }>
				<Col span={ 8 }>
					<SonarText>{ status.jiraStatusLabel }</SonarText>
				</Col>
				<Col span={ 5 }>
					<ArrowRightOutlined />
				</Col>
				<Col span={ 11 }>
					<InitiativeStatusSelector
						defaultValue={ defaultValue }
						loading={ !isReceived }
						noConfetti
						onChange={ handleStatusChange(status.jiraStatusId) } />
				</Col>
			</Row>
			<AsyncStateNotification
				errored={ COPY_GENERIC.CONTACT_SUPPORT }
				failed={ COPY_GENERIC.CONTACT_SUPPORT }
				resetRawAction={ integrationsActions.resetPostJiraStatuses }
				stateSelector={ jiraStatusSelectors.state } />
		</div>
	);
};
